/* eslint-disable */
import axios from "axios";
import jwt_decode from "jwt-decode";
import VuePdfEmbed from "vue-pdf-embed";
import customModal from "../customModal/customModal.vue";
import store from "../../store/index";

const PROTOCOL_UPLOAD_URL =
  `${process.env.VUE_APP_Service_URL}/etmf/document/uploaddocument`;
const EXTRACTION_CREATE_URL =
  `${process.env.VUE_APP_Service_URL}/management/extraction/create`;
const PROTOCOL_EXTRACTION_WEBHOOKS = {
  CtQ: process.env.VUE_APP_N8N_CTQ,
  SoA: process.env.VUE_APP_N8N_SOA,
  "Edit Check": process.env.VUE_APP_N8N_EDIT_CHECK,
  "eCRF Forms": process.env.VUE_APP_N8N_eCRF_FORMS,
};

const PROTOCOL_EXTRACTION_WEBHOOK_TIMEOUTS = {
  default: 10 * 60 * 1000,
  "Edit Check": 30 * 60 * 1000,
};

const PROTOCOL_EXTRACTION_ACTIONS = ["CtQ", "SoA", "Edit Check","eCRF Forms"];

export default {
  name: "f4p",
  components: {
    VuePdfEmbed,
    customModal,
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      source: "",
      studyFiles: [],
      showLoading: false,
      showValidation: false,
      readyToView: false,
      isLandscape: false,
      showProtocolExtractionActions: false,
      selectedProtocolExtractionActions: [],
      protocolExtractionActions: PROTOCOL_EXTRACTION_ACTIONS,
      protocolUploadedPdfFile: null,
      protocolExtractionPdfId: "",
      protocolActionLoading: "",
      protocolActionStatusType: "",
      protocolActionStatusMessage: "",
      documentId: "",
      protocolName: "",
    };
  },
  methods: {
    closeAssignModal() {
      this.$emit("closemodel");
    },
    previewFiles(event) {
      this.showValidation = false;
      this.studyFiles = Array.from(event.target.files);
      this.showProtocolExtractionActions = false;
      this.protocolUploadedPdfFile = null;
      this.protocolExtractionPdfId = "";
      this.protocolActionLoading = "";
      this.protocolActionStatusType = "";
      this.protocolActionStatusMessage = "";
      this.selectedProtocolExtractionActions = [];
      this.protocolName = "";
    },
    async protocolExport() {
      const uploadedFile = this.studyFiles?.[0];

      if (!uploadedFile) {
        this.showValidation = true;
        this.readyToView = false;
        return;
      }

      this.showValidation = false;
      this.source = URL.createObjectURL(uploadedFile);
      this.readyToView = true;

      this.showLoading = true;
      try {
        const uploadResponse = await this.uploadProtocolDocument(uploadedFile);
        const documentId = uploadResponse?.data?.documentId;
        this.documentId = documentId;
        this.protocolName = this.getFileNameWithoutExtension(
          uploadedFile.name
        );

        if (!documentId) {
          throw new Error("Document upload completed without a documentId.");
        }

        this.protocolUploadedPdfFile = uploadedFile;
        this.protocolExtractionPdfId = "";
        this.showProtocolExtractionActions = true;
        this.selectedProtocolExtractionActions = [];
        this.protocolActionStatusType = "success";
        this.protocolActionStatusMessage =
          "";
      } catch (err) {
        console.log("error in protocol export", err);
        const errMsg =
          err?.response?.data?.detail ||
          err?.response?.data?.message ||
          err?.response?.data?.title ||
          err?.message ||
          "Protocol export failed";
        alert(errMsg);
      } finally {
        this.showLoading = false;
      }
    },
    getFileNameWithoutExtension(fileName = "") {
      return fileName.replace(/\.[^.]+$/, "");
    },
    getExtractionPdfId(responseData) {
      if (!responseData) {
        return "";
      }

      if (typeof responseData === "string") {
        return responseData;
      }

      return (
        responseData.pdfId ||
        responseData.id ||
        responseData.extractionId ||
        responseData.data?.pdfId ||
        responseData.data?.id ||
        responseData.data?.extractionId ||
        ""
      );
    },
    uploadProtocolDocument(file) {
      const formData = new FormData();
      const idtoken = store.getters.getIdToken;
      formData.append("File", file);

      return axios.post(PROTOCOL_UPLOAD_URL, formData, {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "multipart/form-data",
        },
      });
    },
    toggleProtocolExtractionAction(action) {
      if (this.protocolActionLoading !== "") {
        return;
      }

      if (this.selectedProtocolExtractionActions.includes(action)) {
        this.selectedProtocolExtractionActions =
          this.selectedProtocolExtractionActions.filter(
            (selectedAction) => selectedAction !== action
          );
        return;
      }

      this.selectedProtocolExtractionActions = [
        ...this.selectedProtocolExtractionActions,
        action,
      ];
    },
    formatProtocolActionList(actions) {
      if (!actions.length) {
        return "";
      }

      if (actions.length === 1) {
        return actions[0];
      }

      if (actions.length === 2) {
        return actions.join(" and ");
      }

      return `${actions.slice(0, -1).join(", ")}, and ${
        actions[actions.length - 1]
      }`;
    },
    async handleProtocolExtractionAction() {
      if (!this.protocolUploadedPdfFile) {
        alert("Please complete protocol import before running this action.");
        return;
      }

      const selectedActions = [...this.selectedProtocolExtractionActions];
      const selectedActionLabel = this.formatProtocolActionList(selectedActions);

      if (!selectedActions.length) {
        alert("Please select at least one extraction action.");
        return;
      }

      this.protocolActionLoading = "selected";
      this.protocolActionStatusType = "info";
      this.protocolActionStatusMessage = `Running ${selectedActionLabel}...`;

      try {
        const extractionResponse = await this.createExtraction(
          this.protocolName ||
            this.getFileNameWithoutExtension(
              this.protocolUploadedPdfFile?.name || ""
            ),
          this.documentId,
          selectedActions
        );
        this.protocolExtractionPdfId = this.getExtractionPdfId(
          extractionResponse?.data
        );

        const failures = [];
        const successMessages = [];

        for (const currentAction of selectedActions) {
          try {
            const responseMessage =
              await this.executeProtocolExtractionWebhook(currentAction);
            successMessages.push(responseMessage);
          } catch (err) {
            failures.push({
              action: currentAction,
              message:
                err?.response?.data?.detail ||
                err?.message ||
                `${currentAction} failed`,
            });
          }
        }

        if (failures.length) {
          throw new Error(
            failures
              .map((item) => `${item.action}: ${item.message}`)
              .join(" | ")
          );
        }

        this.protocolActionStatusType = "success";
        this.protocolActionStatusMessage = successMessages[0];
          // selectedActions.length === 1
          //   ? successMessages[0] ||
          //     `${selectedActions[0]} completed successfully.`
          //   : `${selectedActionLabel} completed successfully.`;
      } catch (err) {
        console.log("error in protocol extraction action", err);
        this.protocolActionStatusType = "error";
        this.protocolActionStatusMessage =
          err?.message ||
          `${selectedActionLabel} failed due to an unexpected error.`;
        alert(this.protocolActionStatusMessage);
      } finally {
        this.protocolActionLoading = "";
      }
    },
    buildProtocolExtractionFormData() {
      const formData = new FormData();
      const idtoken = store.getters.getIdToken;
      const email = jwt_decode(idtoken).email;

      formData.append(
        "PDF",
        this.protocolUploadedPdfFile,
        this.protocolUploadedPdfFile?.name || "protocol.pdf"
      );
      formData.append("email", email || "");
      formData.append("pdfId", this.documentId);

      return formData;
    },
    async executeProtocolExtractionWebhook(action) {
      const webhookUrl = PROTOCOL_EXTRACTION_WEBHOOKS[action];

      if (!webhookUrl) {
        throw new Error(`No webhook configured for ${action}.`);
      }

      const response = await axios.post(
        webhookUrl,
        this.buildProtocolExtractionFormData(),
        {
          responseType: "blob",
          timeout:
            PROTOCOL_EXTRACTION_WEBHOOK_TIMEOUTS[action] ||
            PROTOCOL_EXTRACTION_WEBHOOK_TIMEOUTS.default,
        }
      );
      // if (response && response.status == 200) {
      //   const contentType = response.headers?.["content-type"] || "";
      //   const contentDisposition = response.headers?.["content-disposition"] || "";
      //   const matchedName = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(contentDisposition);

      //   const fileType = contentType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      //   const fileName = matchedName
      //     ? decodeURIComponent(matchedName[1] || matchedName[2])
      //     : `${this.protocolName || "protocol"}_${action.toLowerCase().replace(/\s+/g, "_")}.xlsx`;

      //   const blob = new Blob([response.data], { type: fileType });
      //   const file = new File([blob], fileName, { type: fileType });

      //   this.CreateDataScrap(file, this.documentId);
      // }
      return await this.handleProtocolExtractionWebhookResponse(
        action,
        response
      );
    },
    async CreateDataScrap(file, refId) {
      const formData = new FormData();
      if (Array.isArray(file)) {
        file.forEach(f => formData.append("file", f)); 
      } else {
        formData.append("file", file);
      }

      try {
        const idtoken = store.getters.getIdToken;
        const response = await axios.post(
          `${this.baseurl}/management/studyprotocol/importprotocol?protocolRefId=${refId}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("Processed file saved", response);
      } catch (error) {
        console.error("Error saving data", error);
      }
    },
    async handleProtocolExtractionWebhookResponse(action, response) {
      const responseBlob =
        response?.data instanceof Blob
          ? response.data
          : new Blob([response?.data], {
              type:
                response?.headers?.["content-type"] ||
                "application/octet-stream",
            });
      const contentDisposition = response?.headers?.["content-disposition"] || "";
      const contentType =
        response?.headers?.["content-type"] || responseBlob?.type || "";

      if (
        this.shouldDownloadProtocolExtractionResponse(
          contentDisposition,
          contentType
        )
      ) {
        const fileName = this.getProtocolExtractionDownloadName(
          action,
          contentDisposition,
          contentType
        );
        this.downloadProtocolExtractionBlob(responseBlob, fileName);
        return `${action} completed successfully.`;
      }

      if (typeof responseBlob.text === "function") {
        const responseText = (await responseBlob.text()).trim();
        if (responseText) {
          return responseText;
        }
      }

      return `${action} completed successfully.`;
    },
    shouldDownloadProtocolExtractionResponse(contentDisposition, contentType) {
      if (contentDisposition) {
        return true;
      }

      return /(application\/zip|application\/octet-stream|application\/pdf|application\/vnd|image\/|text\/csv)/i.test(
        contentType
      );
    },
    getProtocolExtractionDownloadName(action, contentDisposition, contentType) {
      const matchedName =
        /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(
          contentDisposition
        );

      if (matchedName) {
        return decodeURIComponent(matchedName[1] || matchedName[2] || "");
      }

      const baseName =
        this.protocolUploadedPdfFile?.name?.replace(/\.[^.]+$/, "") ||
        "protocol";
      const normalizedAction = action.toLowerCase().replace(/\s+/g, "_");
      return `${baseName}_${normalizedAction}${this.getProtocolExtractionFileExtension(
        contentType
      )}`;
    },
    getProtocolExtractionFileExtension(contentType) {
      if (/zip/i.test(contentType)) {
        return ".zip";
      }
      if (/pdf/i.test(contentType)) {
        return ".pdf";
      }
      if (/spreadsheetml|excel/i.test(contentType)) {
        return ".xlsx";
      }
      if (/csv/i.test(contentType)) {
        return ".csv";
      }
      if (/json/i.test(contentType)) {
        return ".json";
      }
      if (/plain/i.test(contentType)) {
        return ".txt";
      }
      return ".bin";
    },
    downloadProtocolExtractionBlob(blob, fileName) {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },
    createExtraction(protocolName, protocolDocumentId, selectedActions = []) {
      const idtoken = store.getters.getIdToken;
      const payload = {
        protocolName: protocolName || "",
        protocolDocumentId: protocolDocumentId || "",
        editCheckDocumentId: "",
        ctqDocumentId: "",
        cdashDocumentId: "",
        ecrfDocumentId: "",
        requesterEmail: "",
        soaDocumentId: "",
        soaStatus: selectedActions.includes("SoA") ? "In Progress" : "",
        editCheckStatus: selectedActions.includes("Edit Check")
          ? "In Progress"
          : "",
        ctqStatus: selectedActions.includes("CtQ") ? "In Progress" : "",
        cdashStatus: "",
        ecrfStatus: selectedActions.includes("eCRF Forms") ? "In Progress" : "",
      };

      return axios.post(EXTRACTION_CREATE_URL, payload, {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      });
    },
  },
};
